<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "Link" });
import "tailwindcss/tailwind.css";
import { t } from "svelte-i18n";
import { Link } from "svelte-navigator";
export let url;
export let label = "";
export let css = "";
const HAS_SLOT = "default" in $$slots;
$: isExternalLink = typeof url === "string" && (url.startsWith("http") || url.startsWith("mailto"));
</script>

{#if url !== undefined || HAS_SLOT || Boolean(label) }

    {#if url?.startsWith('#') }

        <a href = { url } class = { `text-inherit ${ css }`} on:click>
            {#if HAS_SLOT } <slot></slot> {/if}
            {#if Boolean(label) } { $t(label.toString()) } {/if}
            {#if !HAS_SLOT && !Boolean(label) } { url } {/if}
        </a>

    {:else if isExternalLink }

        <a href = { url } class = { `text-inherit ${ css }`} target = '_blank' rel = 'noreferrer' on:click>
            {#if HAS_SLOT } <slot></slot> {/if}
            {#if Boolean(label) } { $t(label.toString()) } {/if}
            {#if !HAS_SLOT && !Boolean(label) } { url } {/if}
        </a>

    {:else}

        {#if url !== undefined }

            <Link to = { url } class = { `text-inherit ${ css }`} on:click>
                {#if HAS_SLOT } <slot></slot> {/if}
                {#if Boolean(label) } { $t(label.toString()) } {/if}
                {#if !HAS_SLOT && !Boolean(label) } { url } {/if}
            </Link>

        {/if}

    {/if}

{/if}